 
export class EndpointSettings {
  
  // private _httpOperation:string;
  
  // set httpOperation(value) {
  //   this._httpOperation = value;
  // }
  //  get httpOperation() {
  //   return this._httpOperation;
  // }

   private _updateLocalUser: boolean;
 
  set updateLocalUser(value) {
    this._updateLocalUser = value;
  }
   get updateLocalUser() {
    return this._updateLocalUser;
  }

  constructor(updateLocalUser:boolean) {     
    this._updateLocalUser = updateLocalUser;    
  }

  // constructor(settings?: EndpointSettings) {
  //   if (settings) {
  //     this._updateLocalUser = settings._updateLocalUser;   
  //    // this.httpOperation = settings._httpOperation;   
  //   }
  // }

 


}
